import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setBalance(state, payload) {
    state.balance = payload;
  },
  addTransactions(state, payload) {
    state.transactions.push(...payload);
  },
};
